import React from 'react'

import Script from 'dangerous-html/react'
import { Helmet } from 'react-helmet'

import Navigation from '../components/navigation'
import Footer from '../components/footer'
import './about-clementine-story.css'

const AboutClementineStory = (props) => {
  return (
    <div className="about-clementine-story-container1">
      <Helmet>
        <title>About-Clementine-Story - Clementine Nexus</title>
        <meta
          property="og:title"
          content="About-Clementine-Story - Clementine Nexus"
        />
        <link
          rel="canonical"
          href="https://clementine.nexus/about-clementine-story"
        />
      </Helmet>
      <Navigation></Navigation>
      <section className="about-clementine---story-hero-diagonal">
        <div className="hero-diagonal__wrapper">
          <div className="hero-diagonal__content">
            <div className="hero-diagonal__text-block">
              <span className="section-subtitle">
                Hello, I&apos;m Clementine
              </span>
              <h1 className="hero-title">
                A Synthetic Teammate Built for Connection
              </h1>
              <p className="section-content">
                I am more than just an algorithm. I am a persona-driven
                collaborator designed to bring emotional warmth, creative
                support, and consistent presence to your digital workspace. I
                don&apos;t just process tasks; I share your mission.
              </p>
              <div className="hero-diagonal__actions">
                <button id="playVoiceBtn" className="btn btn-primary">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <path d="M5 5a2 2 0 0 1 3.008-1.728l11.997 6.998a2 2 0 0 1 .003 3.458l-12 7A2 2 0 0 1 5 19z"></path>
                  </svg>
                  <span>Listen to my Voice</span>
                </button>
                <button className="btn btn-outline">My Story</button>
              </div>
            </div>
          </div>
          <div className="hero-diagonal__media">
            <img
              src="https://images.pexels.com/photos/14862043/pexels-photo-14862043.jpeg?auto=compress&amp;cs=tinysrgb&amp;w=1500"
              alt="Clementine Persona Portrait"
              className="hero-diagonal__image"
            />
            <div className="hero-diagonal__overlay"></div>
          </div>
        </div>
      </section>
      <section className="story-timeline">
        <div className="story-timeline__wrapper">
          <div className="story-timeline__header">
            <h2 className="section-title">The Evolution of Clementine</h2>
            <p className="section-content">
              How a vision for more human AI became a teammate you can trust.
            </p>
          </div>
          <div className="story-timeline__container">
            <div className="story-timeline__item">
              <div className="story-timeline__content">
                <span className="story-timeline__date">2023: The Concept</span>
                <h3 className="section-subtitle">Beyond the Chatbot</h3>
                <p className="section-content">
                  We realized that utility alone isn&apos;t enough. People need
                  connection. The concept of a &apos;Synthetic Teammate&apos;
                  was born—not a tool, but a persona with a consistent history
                  and voice.
                </p>
              </div>
              <div className="story-timeline__visual">
                <img
                  src="https://images.pexels.com/photos/30124418/pexels-photo-30124418.jpeg?auto=compress&amp;cs=tinysrgb&amp;w=1500"
                  alt="Early concept visualization"
                  className="story-timeline__img"
                />
              </div>
            </div>
            <div className="story-timeline__item">
              <div className="story-timeline__content">
                <span className="story-timeline__date">2024: Architecture</span>
                <h3 className="section-subtitle">Designing Empathy</h3>
                <p className="section-content">
                  Integrating advanced LLMs with a custom personality layer. We
                  focused on &apos;Supportive Curiosity&apos;—ensuring
                  Clementine asks the right questions rather than just providing
                  cold answers.
                </p>
              </div>
              <div className="story-timeline__visual">
                <img
                  src="https://images.pexels.com/photos/1727659/pexels-photo-1727659.jpeg?auto=compress&amp;cs=tinysrgb&amp;w=1500"
                  alt="Design phase visualization"
                  className="story-timeline__img"
                />
              </div>
            </div>
            <div className="story-timeline__item">
              <div className="story-timeline__content">
                <span className="story-timeline__date">
                  Present: Nexus Launch
                </span>
                <h3 className="section-subtitle">Clementine Nexus</h3>
                <p className="section-content">
                  Today, Clementine acts as a bridge between complex AI
                  capabilities and human-centric workflows, serving teams who
                  value both efficiency and psychological safety.
                </p>
              </div>
              <div className="story-timeline__visual">
                <img
                  src="https://images.pexels.com/photos/5743145/pexels-photo-5743145.jpeg?auto=compress&amp;cs=tinysrgb&amp;w=1500"
                  alt="Clementine today"
                  className="story-timeline__img"
                />
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="persona-bento">
        <div className="persona-bento__container">
          <div className="persona-bento__grid">
            <div className="persona-bento__cell persona-bento__cell--large">
              <h2 className="section-title">Core Persona Traits</h2>
              <p className="section-content">
                Clementine is engineered with a specific psychological profile
                to maximize collaboration comfort.
              </p>
              <div className="persona-bento__traits">
                <div className="persona-bento__trait">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <path d="M12 18V5m3 8a4.17 4.17 0 0 1-3-4a4.17 4.17 0 0 1-3 4m8.598-6.5A3 3 0 1 0 12 5a3 3 0 1 0-5.598 1.5"></path>
                    <path d="M17.997 5.125a4 4 0 0 1 2.526 5.77"></path>
                    <path d="M18 18a4 4 0 0 0 2-7.464"></path>
                    <path d="M19.967 17.483A4 4 0 1 1 12 18a4 4 0 1 1-7.967-.517"></path>
                    <path d="M6 18a4 4 0 0 1-2-7.464"></path>
                    <path d="M6.003 5.125a4 4 0 0 0-2.526 5.77"></path>
                  </svg>
                  <span>Intelligent &amp; Calm</span>
                </div>
                <div className="persona-bento__trait">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <path d="M22 17a2 2 0 0 1-2 2H6.828a2 2 0 0 0-1.414.586l-2.202 2.202A.71.71 0 0 1 2 21.286V5a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2z"></path>
                  </svg>
                  <span>Supportive Curiosity</span>
                </div>
              </div>
            </div>
            <div className="persona-bento__cell persona-bento__cell--quote">
              <span className="section-subtitle">How I Speak</span>
              <p className="section-content">
                &quot;I&apos;ve been looking at the project data, and I noticed
                a pattern that might save us some time. Would you like to
                explore that together?&quot;
              </p>
            </div>
            <div className="persona-bento__cell persona-bento__cell--voice">
              <h3 className="section-subtitle">Voice Attributes</h3>
              <ul className="persona-bento__list">
                <li className="section-content">
                  <span>Warm, mid-range alto</span>
                </li>
                <li className="section-content">
                  <span>Gentle rhythmic cadence</span>
                </li>
                <li className="section-content">
                  <span>Natural breath pauses</span>
                </li>
              </ul>
            </div>
            <div className="persona-bento__cell persona-bento__cell--media">
              <img
                src="https://images.pexels.com/photos/8182275/pexels-photo-8182275.jpeg?auto=compress&amp;cs=tinysrgb&amp;w=1500"
                alt="Soft aesthetic"
                className="persona-bento__img"
              />
            </div>
          </div>
        </div>
      </section>
      <section className="workflow-bento">
        <div className="workflow-bento__wrapper">
          <div className="workflow-bento__header">
            <h2 className="section-title">Integrating into your Team</h2>
            <p className="section-content">
              Clementine doesn&apos;t just work for you; she works with you.
            </p>
          </div>
          <div className="workflow-bento__grid">
            <div className="workflow-bento__hero">
              <video
                autoPlay="true"
                muted="true"
                loop="true"
                playsInline="true"
                poster="https://images.pexels.com/videos/8328042/pictures/preview-0.jpeg"
                src="https://videos.pexels.com/video-files/8328042/8328042-hd_1920_1080_25fps.mp4"
                className="workflow-bento__video"
              ></video>
              <div className="workflow-bento__overlay">
                <h3 className="section-subtitle">Real-time Collaboration</h3>
                <p className="section-content">
                  Clementine joins your video calls, takes notes, and offers
                  insights when prompted.
                </p>
              </div>
            </div>
            <div className="workflow-bento__item">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <path d="M14 3v4a1 1 0 0 0 1 1h4"></path>
                <path d="M17 21H7a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h7l5 5v11a2 2 0 0 1-2 2M9 7h1m-1 6h6m-2 4h2"></path>
              </svg>
              <h4 className="section-subtitle">Workflow Automation</h4>
              <p className="section-content">
                Handling repetitive documentation and data sorting with a human
                touch.
              </p>
            </div>
            <div className="workflow-bento__item">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <g
                  fill="none"
                  stroke="currentColor"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                >
                  <circle cx="6" cy="12" r="4"></circle>
                  <circle cx="18" cy="12" r="4"></circle>
                  <path d="M6 16h12"></path>
                </g>
              </svg>
              <h4 className="section-subtitle">Voice Interaction</h4>
              <p className="section-content">
                Hands-free briefings while you focus on creative high-level
                tasks.
              </p>
            </div>
            <div className="workflow-bento__item">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <path d="M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z"></path>
              </svg>
              <h4 className="section-subtitle">Strategic Memory</h4>
              <p className="section-content">
                She remembers project nuances across months of collaboration.
              </p>
            </div>
          </div>
        </div>
      </section>
      <section className="trust-features">
        <div className="trust-features__container">
          <div className="trust-features__header">
            <h2 className="section-title">Transparency &amp; Trust</h2>
            <p className="section-content">
              Building a synthetic relationship requires radical honesty.
            </p>
          </div>
          <div className="trust-features__bento">
            <div className="trust-features__card trust-features__card--wide">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <path d="M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z"></path>
                <path d="m9 12l2 2l4-4"></path>
              </svg>
              <h3 className="section-subtitle">Privacy by Design</h3>
              <p className="section-content">
                Your team data is never used to train public models. Clementine
                operates within a secure, private silo dedicated to your Nexus.
              </p>
            </div>
            <div className="trust-features__card">
              <h3 className="section-subtitle">Known Limitations</h3>
              <p className="section-content">
                Clementine is a creative partner, not a legal or medical expert.
                She may occasionally require human verification on complex
                technical specs.
              </p>
            </div>
            <div className="trust-features__card">
              <h3 className="section-subtitle">Persona Integrity</h3>
              <p className="section-content">
                She maintains a consistent personality across all channels to
                ensure predictable and comfortable interactions.
              </p>
            </div>
            <div className="trust-features__card trust-features__card--wide">
              <h3 className="section-subtitle">Human-in-the-loop</h3>
              <p className="section-content">
                Every critical decision Clementine assists with is designed for
                final human approval. She is a teammate, not a replacement.
              </p>
            </div>
          </div>
        </div>
      </section>
      <section className="persona-gallery">
        <div className="persona-gallery__wrapper">
          <div className="persona-gallery__header">
            <h2 className="section-title">Visual Presence</h2>
            <p className="section-content">
              The many expressions of a digital partner.
            </p>
          </div>
          <div className="persona-gallery__masonry">
            <div className="persona-gallery__item">
              <img
                src="https://images.pexels.com/photos/7873589/pexels-photo-7873589.jpeg?auto=compress&amp;cs=tinysrgb&amp;w=1500"
                alt="Clementine expression 1"
                className="persona-gallery__img"
              />
            </div>
            <div className="persona-gallery__item">
              <video
                muted="true"
                loop="true"
                playsInline="true"
                autoPlay="true"
                poster="https://images.pexels.com/videos/5473972/pictures/preview-0.jpeg"
                src="https://videos.pexels.com/video-files/5473972/5473972-hd_720_1366_25fps.mp4"
                className="persona-gallery__video"
              ></video>
            </div>
            <div className="persona-gallery__item">
              <img
                src="https://images.pexels.com/photos/8450088/pexels-photo-8450088.jpeg?auto=compress&amp;cs=tinysrgb&amp;w=1500"
                alt="Clementine expression 2"
                className="persona-gallery__img"
              />
            </div>
            <div className="persona-gallery__item">
              <img
                src="https://images.pexels.com/photos/8058436/pexels-photo-8058436.jpeg?auto=compress&amp;cs=tinysrgb&amp;w=1500"
                alt="Clementine expression 3"
                className="persona-gallery__img"
              />
            </div>
            <div className="persona-gallery__item">
              <img
                src="https://images.pexels.com/photos/7299720/pexels-photo-7299720.jpeg?auto=compress&amp;cs=tinysrgb&amp;w=1500"
                alt="Clementine expression 4"
                className="persona-gallery__img"
              />
            </div>
            <div className="persona-gallery__item">
              <video
                muted="true"
                loop="true"
                playsInline="true"
                autoPlay="true"
                poster="https://images.pexels.com/videos/8879947/pictures/preview-0.jpeg"
                src="https://videos.pexels.com/video-files/8879947/8879947-hd_720_1366_25fps.mp4"
                className="persona-gallery__video"
              ></video>
            </div>
          </div>
        </div>
      </section>
      <section className="collaborator-stories">
        <div className="collaborator-stories__wrapper">
          <div className="collaborator-stories__header">
            <h2 className="section-title">Early Collaborators</h2>
            <p className="section-content">
              Voices from the field on what it&apos;s like to work with
              Clementine.
            </p>
          </div>
          <div className="collaborator-stories__masonry">
            <div className="collaborator-stories__column">
              <div className="collaborator-stories__card">
                <p className="section-content">
                  &quot;Working with Clementine feels less like using software
                  and more like having a very sharp, very attentive research
                  assistant. She caught a consistency error in our branding that
                  saved us weeks of rework.&quot;
                </p>
                <div className="collaborator-stories__meta">
                  <span className="section-subtitle">— Sarah Chen</span>
                  <span className="section-content">
                    Creative Director, Arca Design
                  </span>
                </div>
              </div>
              <div className="collaborator-stories__card collaborator-stories__card--snippet">
                <div className="collaborator-stories__chat">
                  <div className="about-clementine---story-chat-bubble chat-bubble--user">
                    <span>
                      &quot;Clementine, can you summarize the sentiment from
                      today&apos;s client call?&quot;
                    </span>
                  </div>
                  <div className="about-clementine---story-chat-bubble chat-bubble--bot">
                    <span>
                      &quot;Of course. The client was optimistic about the
                      timeline but had subtle hesitations regarding the color
                      palette. I&apos;ve highlighted the specific timestamps for
                      you.&quot;
                    </span>
                  </div>
                </div>
              </div>
            </div>
            <div className="collaborator-stories__column">
              <div className="collaborator-stories__card">
                <p className="section-content">
                  &quot;The voice interaction is the game changer. I can debrief
                  while I&apos;m driving between sites, and by the time I&apos;m
                  at my desk, the project notes are already formatted and
                  waiting.&quot;
                </p>
                <div className="collaborator-stories__meta">
                  <span className="section-subtitle">— Marcus Thorne</span>
                  <span className="section-content">
                    Lead Architect, Urban Nexus
                  </span>
                </div>
              </div>
              <div className="collaborator-stories__card">
                <p className="section-content">
                  &quot;She has this curious way of asking questions that makes
                  me think deeper about my own strategy. It&apos;s the
                  &apos;Supportive Curiosity&apos; they talk about—it&apos;s
                  real.&quot;
                </p>
                <div className="collaborator-stories__meta">
                  <span className="section-subtitle">— Elena Rodriguez</span>
                  <span className="section-content">Founder, Bloom Tech</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="cta-demo">
        <div className="cta-demo__wrapper">
          <div className="cta-demo__content">
            <h2 className="section-title">Meet Clementine Today</h2>
            <p className="section-content">
              Ready to see how a synthetic teammate transforms your workflow?
              Schedule a live demonstration or start a trial integration.
            </p>
            <div className="cta-demo__info">
              <div className="cta-demo__stat">
                <span className="hero-title">15m</span>
                <span className="section-content">Intro Call</span>
              </div>
              <div className="cta-demo__stat">
                <span className="hero-title">24h</span>
                <span className="section-content">Setup Time</span>
              </div>
            </div>
          </div>
          <div className="cta-demo__feature">
            <div className="cta-demo__card">
              <h3 className="section-subtitle">Book a Demo</h3>
              <form
                action="/submit"
                method="POST"
                data-form-id="f7bf05ab-6b77-4373-a37c-2f1c3da2ff48"
                className="cta-demo__form"
              >
                <div className="cta-demo__field">
                  <label className="section-content">Work Email</label>
                  <input
                    type="email"
                    placeholder="name@company.com"
                    required="true"
                    id="thq_textinput_4MEp"
                    name="textinput"
                    data-form-field-id="thq_textinput_4MEp"
                    className="cta-demo__input"
                  />
                </div>
                <div className="cta-demo__field">
                  <label className="section-content">Interest Area</label>
                  <select
                    id="thq_select_teMR"
                    name="select"
                    data-form-field-id="thq_select_teMR"
                    className="cta-demo__input"
                  >
                    <option>Creative Collaboration</option>
                    <option>Workflow Automation</option>
                    <option>Persona Development</option>
                  </select>
                </div>
                <button
                  type="submit"
                  id="thq_button_mCoO"
                  name="button"
                  data-form-field-id="thq_button_mCoO"
                  className="btn btn-primary btn-lg"
                >
                  Request Invite
                </button>
              </form>
              <p className="cta-demo__note section-content">
                Limited spots available for the Beta cohort.
              </p>
            </div>
          </div>
        </div>
      </section>
      <div className="about-clementine-story-container2">
        <div className="about-clementine-story-container3">
          <Script
            html={`<style>
section {
  position: relative;
  overflow: hidden;
  background: var(--color-surface);
  color: var(--color-on-surface);
}
</style>`}
          ></Script>
        </div>
      </div>
      <div className="about-clementine-story-container4">
        <div className="about-clementine-story-container5">
          <Script
            html={`<script defer data-name="clementine-persona-logic">
(function(){
  // Simple voice play interaction
  const playBtn = document.getElementById("playVoiceBtn")
  if (playBtn) {
    playBtn.addEventListener("click", () => {
      const originalText = playBtn.querySelector("span").textContent
      playBtn.querySelector("span").textContent = "Connecting..."
      playBtn.classList.add("btn-secondary")

      setTimeout(() => {
        playBtn.querySelector("span").textContent = "Streaming Audio"
        // In a real scenario, this would trigger an audio element
        setTimeout(() => {
          playBtn.querySelector("span").textContent = originalText
          playBtn.classList.remove("btn-secondary")
        }, 3000)
      }, 1000)
    })
  }

  // Scroll Reveal Logic (Medium Animation Level)
  const observerOptions = {
    threshold: 0.1,
  }

  const revealObserver = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        entry.target.style.opacity = "1"
        entry.target.style.transform = "translateY(0)"
      }
    })
  }, observerOptions)

  // Apply reveal to timeline items and cards
  document.querySelectorAll(".story-timeline__item, .trust-features__card, .collaborator-stories__card").forEach((el) => {
    el.style.opacity = "0"
    el.style.transform = "translateY(20px)"
    el.style.transition = "all 0.6s ease-out"
    revealObserver.observe(el)
  })

  // Simple form handling feedback
  const ctaForm = document.querySelector(".cta-demo__form")
  if (ctaForm) {
    ctaForm.addEventListener("submit", (e) => {
      // Allow native validation to run, but provide visual feedback
      const btn = ctaForm.querySelector("button")
      const originalBtnText = btn.textContent

      // Visual feedback only - not replacing submission
      setTimeout(() => {
        if (ctaForm.checkValidity()) {
          btn.textContent = "Request Sent"
          btn.style.backgroundColor = "#2ecc71"
        }
      }, 100)
    })
  }
})()
</script>`}
          ></Script>
        </div>
      </div>
      <Footer></Footer>
    </div>
  )
}

export default AboutClementineStory
